import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { ArticleCard } from '../articles/ArticleCard';

export const CategoryRail = ({ 
  title, 
  slug, 
  articles = [],
  className = ''
}) => {
  // Always render the section, even if no articles (show placeholder message)

  return (
    <section className={`py-8 md:py-12 ${className}`} data-testid={`category-rail-${slug}`}>
      <div className="container-custom">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-serif text-2xl md:text-3xl font-bold">{title}</h2>
          <Link 
            to={`/category/${slug}`}
            className="flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            data-testid={`view-all-${slug}`}
          >
            View All
            <ChevronRight className="h-4 w-4" />
          </Link>
        </div>

        {/* Horizontal Scroll */}
        <div className="horizontal-scroll -mx-4 px-4">
          {articles.map((article) => (
            <div key={article.id} className="w-[280px] md:w-[320px]">
              <ArticleCard article={article} showCategory={false} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryRail;
